import ContentLoader from 'react-content-loader';
import { EMPTY_LIST_SIX } from '../../../../../helpers/emptyListsForMapping';

export const CardsLoader = () => {
  return EMPTY_LIST_SIX.map(({ id }, index) => (
    <div key={`test-${id}`} className={`test-${index} col-span-full sm:col-span-6 md:col-span-4`}>
      <ContentLoader
        uniqueKey={`test-loader-${id}`}
        id={`test-loader-${id}`}
        speed={2}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        className="size-full rounded-lg md:rounded-xl"
      >
        <rect x="0" y="0" width="100%" height="100%" />
      </ContentLoader>
    </div>
  ));
};
